<template>
    <component :is="componentName" 
        :value="value"
        @input="emitInput"
    >
    </component>
</template>

<script>
import DynamicControlHelpers from '../helpers/DynamicControlHelpers'
import CollectionHelpers from '../helpers/CollectionHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        field: Object,
        value: String,
    },

    computed: {
        componentName() {
            return CollectionHelpers.lookupValue(this.controlTypes, 'value', this.field.type, 'control')
        },
        controlTypes() {
            return DynamicControlHelpers.dynamicControlTypes()
        }
    },

    methods: {
        emitInput(newValue) {
            this.$emit('input', newValue)
        },
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DynamicControl.vue?68f7c7e2